(() => {
  const current = document.body.dataset.page || document.querySelector('.kkc-shell')?.dataset.page;
  document.querySelectorAll('.nav a[data-kkc-href]').forEach(link => {
    if (link.dataset.kkcHref.split(/[?#]/)[0] === current) {
      link.setAttribute('aria-current', 'page');
      link.closest('.dropdown')?.classList.add('is-current');
    }
  });
  document.addEventListener('shopify:section:load', () => {
    if (window.KKC) window.KKC.init();
  });
})();
